
import React from 'react'
import icon from './svgs/bookGray.svg'
import { BaseIcon } from './_base'

export const BookGrayIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
